import { Tabs } from "antd";
import styles from "./classes-view-tabs.module.css";
import AcademicView from "../academic-view/academic-view";

export function ClassesViewTabs({ loading, classList, getInstitutionSummary }) { 

  const items = [
    {
      key: "1",
      label: "Academic View",
      children: (
        <AcademicView 
          loading={loading}
          classList={classList} 
          getInstitutionSummary={getInstitutionSummary} 
        />
      ),
    },
    {
      key: "2",
      label: "Nonacademic View",
      children: "",
    },
    {
      key: "3",
      label: "Periods View",
      children: "",
    },
  ];

  return (
    <div className={styles.classes_view_tabs}>
      <Tabs default="1" items={items} tabBarStyle={{ borderBottom: "none" }} />
    </div>
  );
}

export default ClassesViewTabs;
